<h1 mat-dialog-title i18n="@@input-dialog-example.title" oneDialogTitle>
    Download report
</h1>

<div mat-dialog-content oneDialogContent class="localid-dialog-content">
    <p class="subheading">
        Please click the preferred format to download.
    </p>
</div>

<div mat-dialog-actions oneDialogActions>
    
    <button color="primary" mat-flat-button [mat-dialog-close]="'csv'">
        CSV
    </button>

    <button color="primary" mat-flat-button [mat-dialog-close]="'xlsx'" style="margin-left: 8px;">
        Excel
    </button>

    <button one-secondary-button mat-stroked-button [mat-dialog-close]="false" style="margin-left: 8px;">
        Cancel
    </button>

</div>